var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "editable",
          rawName: "v-editable",
          value: _vm.blok,
          expression: "blok",
        },
      ],
      staticClass: "container-fluid",
      class: _vm.styleClasses,
      style: _vm.styleFromProps,
    },
    [
      _c(
        "div",
        { staticClass: "row" },
        _vm._l(_vm.blok.columns, function (blok) {
          return _c(blok.component, {
            key: blok._uid,
            tag: "component",
            attrs: { blok: blok, publishedAt: _vm.publishedAt },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }